import { DarkThemeIcon, LightThemeIcon } from '@/components/icons';
import { IconButton } from '@/components/ui';
import { useTheme } from '@/hooks';
//import { Tooltip } from '@/components/ui';

export const ThemeSwitcher = () => {
  const { isDark, toggleColorMode } = useTheme();

  return (
    <>
      <IconButton
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        onClick={toggleColorMode}
        icon={isDark ? <LightThemeIcon /> : <DarkThemeIcon />}
      />
    </>
  );
};
